import React, { ReactNode } from 'react';
import { Box, BoxProps } from '@design-system/pc';

interface ResponsiveBoxProps {
  children?: ReactNode;
}

const ResponsiveBox = ({
  children,
  ...props
}: ResponsiveBoxProps & Omit<BoxProps, 'as' | 'children'>) => {
  return (
    <Box {...props} width="100%" minWidth={1170} maxWidth={1400} mx="auto">
      {children}
    </Box>
  );
};

export default ResponsiveBox;
